import * as windowService from "../services/windowService";
import * as actionTypes from "../constants/actionTypes";
import * as config from "../constants/config";
import * as localConfig from "../constants/localConfig";
import * as getterHelper from "../helpers/getterHelper";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const connectHelper = () => ({
    type: actionTypes.HELPER_CONNECT,
    payload: {
        url: getterHelper.getUrlByIpAndPort(localConfig.DEFAULT_HELPER, config.HELPER_PORT)
    }
});

export const websocketConnecting = () => {
    windowService.logInfo("Connecting to Helper Server websocket.");

    return {
        type: actionTypes.HELPER_WEBSOCKET_CONNECTING
    };
};

export const websocketOpened = () => {
    windowService.logInfo("Helper Server websocket opened.");

    return {
        type: actionTypes.HELPER_WEBSOCKET_OPENED
    };
};

export const websocketClosed = (event) => {
    windowService.logInfo(
        event.reason !== "" ? "Helper Server websocket closed: " + event.reason : "Helper Server websocket closed."
    );

    return {
        type: actionTypes.HELPER_WEBSOCKET_CLOSED
    };
};

export const websocketResponse = (event) => {
    return {
        type: actionTypes.HELPER_WEBSOCKET_RESPONSE,
        payload: {
            data: event.data
        }
    };
};

export const websocketRequest = (payload) => ({
    type: actionTypes.HELPER_WEBSOCKET_REQUEST,
    payload: payload
});

export const saveWebsocketRequest = (sequence, tabId, method) => ({
    type: actionTypes.SAVE_HELPER_WEBSOCKET_REQUEST,
    payload: {
        sequence: sequence,
        tabId: tabId,
        method: method
    }
});

export const processWebsocketRequest = (tabId, payload, method) => {
    return (dispatch, getState) => {
        let sequence = getState().helper.sequence + 1;
        dispatch(saveWebsocketRequest(sequence, tabId, method));

        payload.sequence = sequence;

        return dispatch(websocketRequest(payload));
    };
};

export const setConfiguration = (configuration) => ({
    type: actionTypes.HELPER_REQUEST,
    payload: {
        type: methods.METHOD_HELPER_SET_CONFIGURATION,
        params: {
            value: {
                Auto: configuration.auto,
                Client: configuration.client
            }
        }
    },
    method: handlers.HELPER_SET_CONFIGURATION,
    tabId: 0
});

export const isHelperOnline = () => ({
    type: actionTypes.HELPER_REQUEST,
    payload: {
        type: methods.METHOD_HELPER_IS_ONLINE
    },
    method: handlers.HELPER_IS_ONLINE,
    tabId: 0
});

export const sendErrorReport = (subject, content, filePaths = []) => ({
    type: actionTypes.SEND_HELPER_BUG_REPORT,
    payload: {
        subject: subject,
        content: content,
        filePaths: filePaths
    }
});

export const saveLogFiles = (path) => ({
    type: actionTypes.SAVE_HELPER_LOG_FILES,
    payload: {
        path: path
    }
});

export const prepareLogFile = () => ({
    type: actionTypes.HELPER_PREPARE_LOG_FILES
});

export const dialogButtonClick = (button, id) => ({
    type: actionTypes.HELPER_REQUEST,
    payload: {
        type: methods.METHOD_HELPER_DIALOG_BUTTON_CLICK,
        params: {
            msgBtn: button,
            dialogID: id
        }
    },
    method: handlers.HELPER_DIALOG_BUTTON_CLICK,
    tabId: 0
});

export const hideHelperDialog = () => ({
    type: actionTypes.HELPER_SAVE_SHOW_DIALOG,
    payload: {
        showDialog: false
    }
});

export const openHelperDialog = () => ({
    type: actionTypes.HELPER_OPEN_DIALOG
});

export const restartServer = () => ({
    type: actionTypes.HELPER_REQUEST,
    payload: {
        type: methods.METHOD_HELPER_RESTART_SERVER
    },
    method: handlers.HELPER_RESTART_SERVER,
    tabId: 0
});
